<template>

    <div class="home">
        <h1 style="text-align: center;line-height: 60px" >变压器仿真</h1>
        <!--        粉末填料页面一-->
        <el-form ref="form" :model="form"
 :rules="rules">

                <el-row >
                    <el-col :span="8" >
                        <div class="max">
                        <el-form-item label="一次側電壓" prop="vac">
                            <el-input  type="number"  v-model.trim.number="form.vac" placeholder="请输入一次侧电压(单位:V)"  />
                        </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                      <div class="max">

                        <el-form-item label="一次側繞組圈數" prop="np">
                            <el-input  type="number"  v-model.trim.number="form.np" placeholder="请输入一次侧绕组圈数"  />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8" >
                        <div class="max">
                        <el-form-item label="一次側電阻" prop="rp">
                            <el-input  type="number" v-model.trim.number="form.rp"  placeholder="请输入一次侧电阻(单位:ohm)"  />
                        </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                        <div class="max">
                            <el-form-item label="二次側繞組圈數" prop="ns">
                                <el-input  type="number" v-model.trim.number="form.ns"  placeholder="请输入二次侧绕组圈数"  />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                        <div class="max">
                        <el-form-item label="二次側電阻" prop="rs">
                            <el-input  type="number" v-model.trim.number="form.rs"  placeholder="请输入二次侧电阻(单位:ohm)"  />
                        </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                            <el-form-item label="頻率" prop="nu">
                                <el-input  type="number" v-model.trim.number="form.nu"  placeholder="请输入频率(单位:Hz)"  />
                            </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="負載功率" prop="lowpower">
                            <el-input  type="number" v-model.trim.number="form.lowpower"  placeholder="请输入负载功率"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <div class="max">
                        <el-form-item label="磁芯電阻率" prop="rc">
                            <el-input  type="number"  v-model.trim.number="form.rc" placeholder="请输入磁芯电阻率(单位:ohm*m)"  />
                        </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="環境溫度" prop="tAir">
                            <el-input  type="number" v-model.trim.number="form.tAir"  placeholder="请输入环境温度(单位:℃)"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <div class="max">
                        <el-form-item label="初始磁導率" prop="muR">
                            <el-input  type="number" v-model.trim.number="form.muR"  placeholder="请输入初始磁导率"  />
                        </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="線徑1" prop="wd">
                            <el-input  type="number"  v-model.trim.number="form.wd" placeholder="请输入线径1(单位:mm)"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="線徑2" prop="wd2">
                            <el-input  type="number" v-model.trim.number="form.wd2"  placeholder="请输入线径2(单位:mm)"  />
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--              摩擦系数结束-->
                <!--              粉末间摩擦系数结束-->

                <el-form-item label="冷卻方式">
                    <el-select v-model="form.model" placeholder="請選擇冷卻方式">
                        <el-option label="自然冷卻" :value="0"></el-option>
                        <el-option label="風冷" :value="1"></el-option>
                        <el-option label="水冷" :value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-row v-if="feng">
                    <el-col :span="8" >
                        <div class="max">
                            <el-form-item label="強制對流熱交換系數" prop="hCoil">
                                <el-input  type="number" v-model.trim.number="form.hCoil" placeholder="请输入强制对流热交换系数(单位:W/m^2/k)"  />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="8" >
                        <div class="max">
                            <el-form-item label="磁芯導熱係數" prop="kc">
                                <el-input  type="number" v-model.trim.number="form.kc"  placeholder="请输入磁芯导热系数" model-value="1.6" disabled />
                            </el-form-item>
                        </div>
                    </el-col>


                </el-row>

                <el-row v-if="shui">
                <el-col :span="8" >
                    <div class="max">
                        <el-form-item label="冷卻水溫" prop="tWater">
                            <el-input  type="number" v-model.trim.number="form.tWater"  placeholder="请输入冷却水温(单位:℃)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="8" >
                    <div class="max">
                        <el-form-item label="磁芯換熱係數" prop="hCore">
                            <el-input  type="number" v-model.trim.number="form.hCore" placeholder="请输入磁芯换热系数(单位:W/m^2/k)" />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="8" >
                    <div class="max">
                        <el-form-item label="線圈冷卻換熱係數" prop="hCoil">
                            <el-input  type="number" v-model.trim.number="form.hCoil" placeholder="请输入线圈冷却换热系数(单位:W/m^2/k)"  />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="8" >
                    <div class="max">
                        <el-form-item label="磁芯導熱係數" prop="kc">
                            <el-input  type="number" v-model.trim.number="form.kc" placeholder="请输入磁芯导热系数" model-value="1.6" disabled />
                        </el-form-item>
                    </div>
                </el-col>

            </el-row>

                <el-form-item label="計算方式">
                    <el-select v-model="form.emulationMode"  placeholder="請選擇計算方式">
                        <el-option label="穩態計算" :value="0"></el-option>
                        <el-option label="瞬態計算:正弦波" :value="1"></el-option>
                        <el-option label="瞬態計算:脈衝波" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-row v-if="jisuan">
                <el-col :span="8" >
                    <div class="max">
                        <el-form-item label="延時" prop="delay">
                            <el-input  type="number" v-model="form.delay" placeholder="请输入延时时间(单位:s)" model-value="30" />
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="8" >
                        <el-form-item label="上升時間" prop="risetime">
                            <el-input  type="number" v-model="form.risetime" placeholder="请输入上升时间(单位:s)"  />
                        </el-form-item>
                </el-col>
                    <el-col :span="8" >
                        <el-form-item label="下降時間" prop="falltime">
                            <el-input  type="number" v-model="form.falltime" placeholder="请输入下降时间(单位:s)"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="脈衝寬度" prop="pulsewidth">
                            <el-input  type="number" v-model="form.pulsewidth"  placeholder="请输入脉冲宽度(单位:mm)" model-value="1.6"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <img src="../../assets/tip.png" alt="" style="width: 657px">
                    </el-col>

            </el-row>

            <div>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="產品名" prop="x">
                            <el-input  v-model.trim="form.x" placeholder="请输入产品名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="材料名" prop="y">
                            <el-input  v-model.trim="form.y" placeholder="请输入材料名称" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="公司名" prop="z">
                            <el-input  v-model.trim="form.z" placeholder="请输入公司名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客戶名" prop="aa">
                            <el-input  v-model.trim="form.aa" placeholder="请输入客户名" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">

                        <el-form-item

                                label="接收圖紙郵箱"
                                prop="bb"
                                :rules="[{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
                                { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]"
                        >
                            <el-input  v-model.trim="form.bb" placeholder="请输入邮箱地址" />
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" :loading=loading>提交數據</el-button>
                    <el-button type="danger" @click="link" :loading=loading>返回</el-button>

                </el-form-item>

            </div>



        </el-form>

    </div>

</template>

<script>
    import request from "@/utils/request";

    export default {
        name: 'IfcoresTransformer',
        props:["formToIfcoresTransformer"],
        data () {
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "值必須大於0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                }

            }

            return {
                feng:false,
                shui:false,
                //冷却方式
                jisuan:false,
                loading:false,
                form:{
                    model:0,
                    emulationMode:0,
                    gridLevel:5,
                    kc:1.6,
                    hCore:5.5,
                    hCoil:5.5,
                    tWater:20,
                    delay: 30,
                    pulsewidth: 1.6
                },
                rules:{
                    vac:[
                        {required: true, message: '一次侧电压是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                        ],
                    np:[
                        {required: true, message: '一次侧绕组圈数是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    rp:[
                        {required: true, message: '一次侧电阻是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    ns:[
                        {required: true, message: '二次侧绕组圈数是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    rs:[
                        {required: true, message: '二次侧电阻是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    nu:[
                        {required: true, message: '频率是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    lowpower:[
                        {required: true, message: '负载功率是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    rc:[
                        {required: true, message: '磁芯电阻率是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    tAir:[
                        {required: true, message: '环境温度是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    muR:[
                        {required: true, message: '初始磁导率是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    wd:[
                        {required: true, message: '线径1是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    wd2:[
                        {required: true, message: '线径2是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    hCoil:[
                        {required: true, message: '强制对流热交换系数是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    kc:[
                        {required: true, message: '磁芯导热系数是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    tWater:[
                        {required: true, message: '冷却水温是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    hCore:[
                        {required: true, message: '磁芯换热系数是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    risetime:[
                        {required: true, message: '上升时间是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    falltime:[
                        {required: true, message: '下降时间是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    pulsewidth:[
                        {required: true, message: '脉冲宽度是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    delay:[
                        {required: true, message: '延时是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    x:[
                        { required: true, message: '產品名是必須數據', trigger: 'blur' },
                    ],
                    y:[
                        { required: true, message: '材料名稱是必須數據', trigger: 'blur' },

                    ],
                    z:[
                        { required: true, message: '公司名是必須數據', trigger: 'blur' },

                    ],
                    aa:[
                        { required: true, message: '客戶名是必須數據', trigger: 'blur' },

                    ],
                    bb:[
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ]
                }
                //


            }
        },
        computed(){

        },
        mounted() {


        },
        created() {


            this.form={...this.formToIfcoresTransformer,...this.form}

        },
        methods: {
            setMsg(val){
                this.form.x=val
            },
            onSubmit(){
                let forms={...this.formToIfcoresTransformer,...this.form}
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        this.loading=true
                        request.post("http://www.magdraw.com/api/list/addDrawlist3",forms).then(res =>{

                            this.form.zz = "127.0.0.1"
                            this.loading = true;
                            if (res.code=='0'){
                                this.loading=false
                                this.$message({
                                    type:"success",
                                    message:"新增成功"
                                })

                            }else{
                                this.loading=false
                                this.$message({
                                    type:"error",
                                    message:res.msg
                                })
                            }

                        })

                    }else{
                        // alert("有报错")
                    }
                })

            },
            link(){
                this.$router.go(-1)
            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val,old){

                    if(val.emulationMode==2){
                        this.jisuan=true

                    }else if(val.emulationMode==1){
                        val.tWater=val.tAir

                        this.jisuan=false

                    }else{

                        val.tWater=20
                        val.hCore=5.5;
                        val.hCoil=5.5;
                        this.jisuan=false

                    }
                    if(val.model==1){
                        this.feng=true
                        this.shui=false
                    }else if(val.model==2){
                        this.feng=false
                        this.shui=true
                    }else{
                        this.feng=false
                        this.shui=false
                    }

                },
                deep:true //true 深度监听
            },



        }


    }
</script>


<style lang="less" scoped>
    i:hover{
        cursor: pointer;
        color: #db261d;
    }
    .border{

        margin-top: 60px;
        height: calc(100vh - 120px);
    }

    .el-input{
        width: 90%;
    }
    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    .max .el-form-item__label{
        line-height: 20px !important;
    }
    .carousel{

        margin-top: 20vh;
        text-align: center;
        img{
            height: 100%;
        }
    }

    @media screen and (max-width:768px){
        .carousel{

            margin: 0;
            padding: 0;

        }
    }
    img:hover{
        cursor: pointer;
    }
    img{
        height: 200px;width: 200px;border: 1px solid #ccc
    }
    .active{
        border: 1px solid orange !important;
    }
</style>

